import React from "react";
import sortBy from "ramda/src/sortBy";
import prop from "ramda/src/prop";

import { IAnswer, ISelectQuestion } from "../../constants/types";
import { Box } from "../../UI/Box";
import { Grid } from "../../UI/Grid";
import { QuestionLayout } from "./QuestionLayout";
import { COLOR_NILE_BLUE, COLOR_SCIENCE_BLUE, COLOR_WHITE } from "../../constants/styles";
import { Typography } from "../../UI/Typography";

const getColor = (isSelected: boolean) => (isSelected ? COLOR_WHITE : COLOR_NILE_BLUE);
const getBgColor = (isSelected: boolean) => (isSelected ? COLOR_SCIENCE_BLUE : COLOR_WHITE);

interface IAnswerButtonProps extends IAnswer {
  isSelected: boolean;
}

const AnswerButton: React.FC<IAnswerButtonProps> = (props) => (
  <Box
    height={32}
    borderRadius={20}
    display="flex"
    alignItems="center"
    justifyContent="center"
    bgcolor={getBgColor(props.isSelected)}
    border={`1px solid ${COLOR_SCIENCE_BLUE}`}
  >
    <Typography color={getColor(props.isSelected)} fontSize={12} fontWeight={600}>
      {props.text || props.answerText}
    </Typography>
  </Box>
);

const Question: React.FC<Pick<ISelectQuestion, "userAnswers" | "answers">> = (props) => (
  <Grid container spacing={1}>
    {Array.isArray(props.answers) &&
      sortBy(prop("answerOrder"), props.answers).map((asw) => (
        <Grid item xs={12} key={asw.id}>
          <AnswerButton {...asw} isSelected={false} />
        </Grid>
      ))}
    {!Array.isArray(props.answers) &&
      sortBy((key) => (props.answers as any)[key].order, Object.keys(props.answers)).map((key) => (
        <Grid item xs={12} key={key}>
          <AnswerButton {...(props.answers as any)[key]} isSelected={!!props.userAnswers?.includes(key)} />
        </Grid>
      ))}
  </Grid>
);

const Respond: React.FC<Pick<ISelectQuestion, "roommateAnswers" | "answers">> = (props) => (
  <Grid container spacing={1}>
    {Array.isArray(props.answers) &&
      sortBy(prop("answerOrder"), props.answers).map((asw) => (
        <Grid item xs={12} key={asw.id}>
          <AnswerButton {...asw} isSelected />
        </Grid>
      ))}
    {!Array.isArray(props.answers) &&
      sortBy((key) => (props.answers as any)[key].order, Object.keys(props.answers)).map((key) => (
        <Grid item xs={12} key={key}>
          <AnswerButton {...(props.answers as any)[key]} isSelected={!!props.roommateAnswers?.includes(key)} />
        </Grid>
      ))}
  </Grid>
);

export const SelectQuestion: React.FC<ISelectQuestion> = (props) => (
  <QuestionLayout
    answers={props.answers}
    title={props.questionText}
    height={Object.values(props.answers).length * 38}
    question={<Question answers={props.answers} userAnswers={props.userAnswers} />}
    respond={<Respond answers={props.answers} roommateAnswers={props.roommateAnswers} />}
  />
);

SelectQuestion.defaultProps = {
  userAnswers: [],
  roommateAnswers: [],
};
